import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noRepository: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.no-repository',
		defaultMessage: 'No repositories',
		description: 'Displayed when a component has no linked repositories.',
	},
	repositories: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.repositories.popup.heading',
		defaultMessage: 'Repositories',
		description: 'Heading of the repositories popup.',
	},
});
